import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/flexible/Paginated';
import { QuestionTemplate, QuestionTemplateOptions } from 'models/flexible/QuestionTemplate';
import type {
  AdminQuestionTemplateIndexFields,
  AdminQuestionTemplateIndexInclude,
  AdminQuestionTemplateMutationParams,
  AdminQuestionTemplateShowFields,
} from 'services/api/fields';
import { BaseIndexQueryParams } from 'services/api/types';
import http from 'services/http';

export const adminQuestionTemplatesQueryKeys = {
  index: (params?: Record<string, any>) => ['adminQuestionTemplates', params] as const,
  show: (id: string) => ['adminQuestionTemplates', id] as const,
};

const URL = 'admin/question_templates';

export type AdminQuestionTemplateIndexParams = BaseIndexQueryParams & {
  type?: string;
  client?: string;
  groupType?: string;
  episode?: string;
  planType?: string;
};

export async function adminIndexQuestionTemplates<I extends AdminQuestionTemplateIndexInclude = never>(
  params: AdminQuestionTemplateIndexParams,
  signal?: GenericAbortSignal,
  includes?: I[]
): Promise<Paginated<QuestionTemplate<AdminQuestionTemplateIndexFields<I>>>> {
  return http
    .get<
      Paginated<QuestionTemplateOptions>
    >(URL, { params: { ...params, ...(includes?.length ? { include: includes.join(',') } : {}) }, signal })
    .then((res) => ({
      ...res.data,
      data: res.data.data.map((x) => new QuestionTemplate(x)),
    })) as Promise<Paginated<QuestionTemplate<AdminQuestionTemplateIndexFields<I>>>>;
}

export async function adminShowQuestionTemplate(
  id: string,
  signal?: GenericAbortSignal
): Promise<QuestionTemplate<AdminQuestionTemplateShowFields>> {
  return http
    .get<QuestionTemplateOptions>(`${URL}/${id}`, { signal })
    .then((res) => new QuestionTemplate(res.data)) as Promise<QuestionTemplate<AdminQuestionTemplateShowFields>>;
}

export async function adminCreateQuestionTemplate(params: AdminQuestionTemplateMutationParams) {
  return http.post<QuestionTemplateOptions>(URL, params).then((res) => new QuestionTemplate(res.data));
}

export async function adminUpdateQuestionTemplate(id: string, params: AdminQuestionTemplateMutationParams) {
  return http.patch<QuestionTemplateOptions>(`${URL}/${id}`, params).then((res) => new QuestionTemplate(res.data));
}
